import React from 'react'

interface RevokedInvitationProps {
  adminEmail: string
}

const RevokedInvitation = ({ adminEmail }: RevokedInvitationProps): React.ReactElement => {
  return (
    <div>
      <h2>Invitation Revoked</h2>
      <p>Your invite was revoked. Please contact admin ({adminEmail}) to request another invite.</p>
    </div>
  )
}

export default RevokedInvitation
